/*
解决问题：1 空图片  2 无效图片  3 懒加载

注意：
组件提供三个变量
src: 要加载图片的地址；
error: src图片地址为空或失效时，要加载的图片地址，如果不传error或者传入的error图片地址已经失效，
则会根据src的异常情况(为空或失效)，使用平台默认的空图片或失效图片；
alt: 替代文本

懒加载机制：图片只有第一次进入视口时才会被加载，不支持IE

*/

import { Component, Input, OnChanges, ElementRef, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { checkImgSrc } from '../../utils/common';

@Component({
  selector: 'icc-image',
  templateUrl: './icc-image.component.html',
  styleUrls: ['./icc-image.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IccImageComponent implements OnChanges {
  // 正常地址
  @Input() src: string;
  // 异常地址
  @Input() error: string;
  // 图像的替代文本
  @Input() alt: string;

  // 当图片的地址验证确定之后，通过事件返回
  @Output() changes: EventEmitter<any> = new EventEmitter<any>();

  /* 与需求确认，都用空地址图片用invalid替代 */
  exceptionUrl = {
    invalid: 'assets/images/nothing/invalid.png',
    empty: 'assets/images/nothing/invalid.png',
  };

  url: string;

  loadUrl: string;

  observer: IntersectionObserver;

  constructor(private el: ElementRef, private cdf: ChangeDetectorRef) {}

  ngOnChanges() {
    const checkSrc = () => {
      checkImgSrc(this.src).then(
        () => {
          // 地址有效
          this.url = this.src;
          this.lazyLoadByObserver();
          this.changes.emit(this.url);
        },
        err => {
          if (err.type === 1) {
            // 地址为空
            console.log('地址为空');
            this.url = this.exceptionUrl.empty;
            this.updateAlt('empty');
            this.lazyLoadByObserver();
            // this.changes.emit(this.url);
            this.changes.emit('empty');
          } else if (err.type === 2) {
            // 地址无效
            console.log('地址无效');
            this.url = this.exceptionUrl.invalid;
            this.updateAlt('invalid');
            this.lazyLoadByObserver();
            // this.changes.emit(this.url);
            this.changes.emit('invalid');
          }
        },
      );
    };
    checkImgSrc(this.error).then(
      () => {
        this.exceptionUrl.empty = this.error;
        this.exceptionUrl.invalid = this.error;
        checkSrc();
      },
      error => {
        checkSrc();
      },
    );
  }

  // 图片地址为空或失效的情况下，如果alt没有被传入，则给予固定显示文本
  updateAlt(typeStr) {
    if (!this.alt) {
      switch (typeStr) {
        case 'empty':
          this.alt = '图片地址为空';
          break;
        case 'invalid':
          this.alt = '图片地址已失效';
          break;
        default:
          break;
      }
    }
  }

  // 使用IntersectionObserver交叉观察器监听图片
  lazyLoadByObserver() {
    if (!IntersectionObserver) return false;
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
            if(this.observer && this.observer.unobserve) {
              this.observer.unobserve(entry.target);
              this.observer = null;
            }
            this.loadUrl = this.url;
            // url改变时，没有实时更新，下面触发强制更新
            this.cdf.markForCheck();    // 进行标注
            this.cdf.detectChanges();   // 要多加一行这个 执行一次变化检测
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: [0],
      },
    );
    this.observer.observe(this.el.nativeElement.children[0]);
  }
}
